module.exports = __webpack_public_path__ + "static/media/115.556f258b.jpg";